module.exports = __webpack_public_path__ + "static/media/auth-bacground.ab8989e4.png";